export const navList = [
  { name: '헌혈요청', url: '/community/donation' },
  { name: '커뮤니티', url: '/community/board' },
  { name: '헌혈의집', url: '/blood-home' },
  { name: '후원', url: '/sponser' },
  { name: '언론보도', url: '/news' },
  { name: '공지사항', url: '/notice' },
];
